import { APP_ID, enableProdMode, importProvidersFrom, LOCALE_ID, provideAppInitializer } from '@angular/core';
import { environment } from '@env/environment';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { Apollo } from 'apollo-angular';
import { GetWorkflowstatusPipe } from '@pipes/get-workflowstatus.pipe';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorInterceptor } from './app/_core/error.interceptor';
import { routes } from './app/app.routes';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GraphQLModule } from './app/graphql.module';
import { StoreModule } from '@ngrx/store';
import { metaReducers, reducers } from './app/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AppComponent } from './app/app.component';
import { provideRouter, TitleStrategy } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { loadMessages, locale } from 'devextreme/localization';
import deMessages from 'devextreme/localization/messages/de.json';
import { applyDevExtremeDefaults } from './app/_core/devextreme-defaults';
import { BreadcrumbTitleStrategy } from './app/_core/breadcrumb-title.strategy';

registerLocaleData(localeDe);

// DevExtreme-Komponenten mit deutschen Texten und Formaten (u. a. 24-Stunden-Format).
loadMessages(deMessages);
locale('de-DE');

export const getBaseUrl = (): string => document.getElementsByTagName('base')[0].href;

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      BrowserAnimationsModule,
      GraphQLModule,
      StoreModule.forRoot(reducers, { metaReducers }),
      ...(environment.production ? [] : [StoreDevtoolsModule.instrument()])
    ),
    Apollo,
    GetWorkflowstatusPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    { provide: Window, useValue: window },
    { provide: APP_ID, useValue: 'ng-cli-universal' },
    { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
    { provide: LOCALE_ID, useValue: 'de-DE' },
    { provide: 'NEBULA_CLIENT_VERSION', useValue: '4.2.0-alpha.6205' },
    provideAppInitializer(applyDevExtremeDefaults),
    provideRouter(routes),
    { provide: TitleStrategy, useClass: BreadcrumbTitleStrategy },
    provideHttpClient(withInterceptorsFromDi())
  ]
}).catch(err => console.log(err));
